import { useState } from 'react'
import { LabLayout } from './app/LabLayout'
import { ConsentBanner } from '@/features/privacy/components/ConsentBanner'
import { PrivacyPanel } from '@/features/privacy/components/PrivacyPanel'
import { CookiePanel } from '@/features/privacy/components/CookiePanel'
import { FirefoxBleNotice } from '@/features/browser/components/FirefoxBleNotice'

export default function App() {
  const [privacyPanelOpen, setPrivacyPanelOpen] = useState(false)
  const [cookiePanelOpen, setCookiePanelOpen] = useState(false)

  return (
    <>
      <LabLayout
        onOpenPrivacyPanel={() => setPrivacyPanelOpen(true)}
        onOpenCookiePanel={() => setCookiePanelOpen(true)}
      />
      <ConsentBanner onOpenCookieSettings={() => setCookiePanelOpen(true)} />
      <FirefoxBleNotice />
      <PrivacyPanel isOpen={privacyPanelOpen} onClose={() => setPrivacyPanelOpen(false)} />
      <CookiePanel isOpen={cookiePanelOpen} onClose={() => setCookiePanelOpen(false)} />
    </>
  )
}
